import api from "../api";

const api_type = 'v1'

export const GetRevenueSelf = params => { return api.post(api_type+`/revenue_self/get_list`, params) }
export const AddRevenueSelf = params => { return api.post(api_type+`/revenue_self/add`, params) }
export const DeleteRevenueSelf = params => { return api.post(api_type+`/revenue_self/delete`, params) }
export const EditRevenueSelf = params => { return api.post(api_type+`/revenue_self/edit`, params) }




// WEBPACK FOOTER //
// ./src/api/v1/revenue_self_api.js